module.exports = __webpack_public_path__ + "media/images/favoris blanc-5f3141a698d7852367881f10e8a1e89a.svg";